import { Component } from 'react';
import css from 'styled-jsx/css';
import PropTypes from 'prop-types';
import { colors, fonts } from '../common/Theme';
import Button from '../common/elements/Button';
import { SIMULATION_HREF } from '../../../pages/assurance/simulation';
import Link from 'next/link';

const TITLE_BREAK = 960;
const DESCRIPTION_BREAK = 700;

const styles = css`
  .banner {
    position: relative;
    background: url('/static/images/home-background.jpg') center / cover
      rgb(${colors.ywgBannerBackgroundRgb}) no-repeat;
    margin: 0;
    display: block;
  }
  .banner::after {
    background: #ffffff url('/static/images/plane-1.svg') calc(100vw - 211px)
      bottom no-repeat;
    content: '';
    display: block;
    left: 0;
    bottom: -346px;
    width: 100vw;
    height: 346px;
    position: absolute;
    z-index: -1;
  }
  .wrapper {
    max-width: 990px;
    min-height: 300px;
    margin: auto;
    padding: 50px 20px 20px;
    background-color: rgba(${colors.ywgBannerBackgroundRgb}, 0.8);
  }
  @media (min-width: ${TITLE_BREAK}px) {
    .wrapper {
      padding: 80px 80px 243px;
      background-color: initial;
    }
  }

  .title {
    color: #ffffff;
    font-family: ${fonts.primaryFont};
    font-size: 2rem;
    text-transform: uppercase;
    padding: 0 0 30px;
    margin: 0;
  }

  @media (min-width: ${TITLE_BREAK}px) {
    .title {
      font-size: 2.625rem;
      line-height: 3.75rem;
      padding: 0 0 40px;
      max-width: 75%;
    }
  }
  .description {
    color: #ffffff;
    opacity: 1;
    padding: 0;
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-family: ${fonts.secondaryFont};
    margin: 0;
  }

  @media (min-width: ${DESCRIPTION_BREAK}px) {
    .description {
      padding: 0 0 20px 0;
      font-size: 1.25rem;
      line-height: 2rem;
      max-width: 75%;
    }
  }

  @media (min-width: ${TITLE_BREAK}px) {
    .description {
      max-width: 50%;
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
  }
  @media (min-width: 400px) {
    .actions {
      flex-direction: row;
    }
  }
`;
const dynamicStyles = css.resolve`
  .button {
    margin-right: 12px;
  }
  .secondary {
    margin-top: 24px;
    align-self: center;
    color: ${colors.ywgPrimary};
    text-decoration: underline;
  }
  @media (min-width: ${TITLE_BREAK}px) {
    .button {
      margin-right: 24px;
    }
  }
`;
const ANIMATION_ELEMENT_ID = 'js-community-animation';

const AnimatedSpan = ({ children, ...props }) => (
  <span {...props}>
    {children}
    <style jsx>{`
      span {
        display: inline-block;
        background: transparent;
        border-radius: 5px;
        height: 5px;
        box-shadow: 0 34px 0 0 ${colors.ywgPinkishOrange};
        animation: titleAnimation 4s infinite;
      }
      @media (min-width: ${TITLE_BREAK}px) {
        span {
          box-shadow: 0 55px 0 0 ${colors.ywgPinkishOrange};
        }
      }
      @keyframes titleAnimation {
        0% {
          opacity: 0;
          transform: translateY(-10px);
        }
        30% {
          transform: translateY(0);
          opacity: 1;
        }
        60% {
          transform: translateY(0);
          opacity: 1;
        }
        90% {
          transform: translateY(10px);
          opacity: 0;
        }
        100% {
          opacity: 0;
        }
      }
    `}</style>
  </span>
);

class Banner extends Component {
  state = {
    wordIdx: -1
  };
  componentDidMount() {
    this.animationId = this.animateTitle();
  }

  componentWillUnmount() {
    clearImmediate(this.animationId);
  }

  animateTitle = () => {
    const animatedText = document.getElementById(ANIMATION_ELEMENT_ID);

    this.setState(
      (state, props) => ({
        wordIdx: (state.wordIdx + 1) % props.banner.animatedWords.length
      }),
      () => {
        animatedText.innerText = this.props.banner.animatedWords[
          this.state.wordIdx
        ];
      }
    );
  };
  render() {
    const { title, description, primary_action } = this.props.banner;
    return (
      <section className="banner">
        <div id="banner" className="wrapper">
          <h1 className="title">
            {title}
            <AnimatedSpan
              id={ANIMATION_ELEMENT_ID}
              onAnimationIteration={this.animateTitle}
            >
              baroudeurs
            </AnimatedSpan>
          </h1>
          <p className="description">{description}</p>
          <div className="actions">
            <Link href={SIMULATION_HREF}>
              <Button
                className={dynamicStyles.className}
                href={SIMULATION_HREF}
                shadowed
              >
                {primary_action}
              </Button>
            </Link>
          </div>
        </div>
        <style jsx>{styles}</style>
        {dynamicStyles.styles}
      </section>
    );
  }
}
Banner.propTypes = {
  titleText: PropTypes.string,
  animatedWords: PropTypes.array,
  description: PropTypes.string,
  action: PropTypes.string
};

export default Banner;
